import api from '@/services/api'

export default {
  /**
   * Get users
   * @return {Array} users
   */
  async getAll () {
    try {
      const res = await api.get('/users')
      return res.data
    } catch (error) {
      throw `Users api service ${error}`
    }
  },

  /**
   * Create users
   * @param {Object} {firstName: String, lastName: String, roles: Array}
   * @return {Number} id
   */
  async create (users) {
    try {
      const res = await api.post('/users', users)
      return res.data.id
    } catch (error) {
      if (error.response.status === 403) {
        throw 'users limit reached'
      }
      throw `Users api service ${error}`
    }
  },

  /**
   * Update current user password
   * @param {String} newPassword 
   */
  async update (users) {
    try {
      const res = await api.put('/users/' + users.id, users)
      return res.data
    } catch (error) {
      throw `Users api service ${error}`
    }
  },

  /**
   * Update user picture
   * @param {Number} id
   * @param {File} picture
   * @return {String} picture name
   */
  async updatePicture (id, logo) {
    try {
      let formData = new FormData()
      formData.append('file', logo)
      const res = await api.post('/users/' + id + '/picture', formData)
      return res.data
    } catch (error) {
      throw `Users api service ${error}`
    }
  },

  /**
   * Delete one users by id
   * @param {Number} id
   */
  async delete (id) {
    try {
      const res = await api.delete('/users/' + id)
      return res.data
    } catch (error) {
      throw `Users api service ${error}`
    }
  },

  /**
   * Set new password for unlogged user
   */
  async newPassword (token, password) {
    try {
      await api.patch('/newpassword', {
        password,
        token
      })
    } catch (error) {
      throw `Users api service ${error}`
    }
  },

  /**
   * Ask for reinit user password
   */
  async askForgotPassword (email) {
    try {
      await api.post('/resetpassword', {
        email
      })
    } catch (error) {
      throw `Users api service ${error}`
    }
  }
}